import { render, staticRenderFns } from "./DevicesList.vue?vue&type=template&id=18db912d&scoped=true&lang=pug&"
import script from "./DevicesList.vue?vue&type=script&lang=js&"
export * from "./DevicesList.vue?vue&type=script&lang=js&"
import style0 from "./DevicesList.vue?vue&type=style&index=0&id=18db912d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db912d",
  null
  
)

export default component.exports